<template>
  <c-card class="row br6">
    <template #header>
      <div class="flex-between-center">
        <div class="flex-start-center">
          <van-image
            v-if="item.avatar"
            :src="item.avatar"
            width="40"
            height="40"
            round
          ></van-image>
          <van-image
            v-else
            class="avatar"
            :src="item.sex == 1 ? require('@/assets/images/patient_m.png') : require('@/assets/images/patient_w.png')"
            width="40"
            height="40"
          ></van-image>
          <span class="ml4">{{ item.cardName }}</span>
          <span class="ml4">{{ item.sexName }}</span>
          <span class="ml4 mr12">{{ item.age }}岁</span>
          <van-tag type="primary" plain round v-if="item.label === 1">接诊中</van-tag>
          <van-tag type="warning" plain round v-if="item.label === 2">候诊中</van-tag>
          <van-tag type="danger" plain round v-if="item.label === 3">待候诊</van-tag>
        </div>
        <div class="c999">{{ item.createTime }}</div>
      </div>
    </template>
    <div class="bottom">
      <div class="dark mb8">就诊号: {{ item.businessId }}</div>
      <div class="dark van-multi-ellipsis--l2">病情描述: {{ item.decription }}</div>
    </div>
    <template #footer>
      <div class="flex-between-center">
        <div v-if="item.label === 1" class="primary" @click="handleAction(item)">提醒并叫号</div>
        <div v-if="item.label === 2" class="primary" @click="handleAction(item)">叫号</div>
        <div v-if="item.label === 3" class="primary" @click="handleAction(item)">提醒</div>
        <div v-if="item.label !== 3" class="primary" @click="toVideoDetailPage(item)">详情</div>
      </div>
    </template>
  </c-card>
</template>

<script>
import cCard from '@/components/cCard.vue';

export default {
  components: { cCard },
  name: 'ConsultRow',
  props: {
    item: Object,
  },
  methods: {
    toVideoDetailPage() {
      this.$router.push({
        path: '/yisheng/videoDetail',
        query: {
          businessId: this.item.businessId,
        },
      });
    },
    handleAction(item) {
      if (item.label === 1) {
        this.$get(`/api/blade-consult/doctorWorkVideo/remindUser/${item.businessId}`)
          .then(() => {
            this.toVideoDetailPage();
          });
      } else if (item.label === 2) {
        this.toVideoDetailPage();
      } else if (item.label === 3) {
        this.$get(`/api/blade-consult/doctorWorkVideo/remindUser/${item.businessId}`)
          .then(() => {
            this.$toast.success('提醒成功！');
          });
      }
    },
    showReject() {
      this.$dialog.alert({
        message: this.item.rejectedReason,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  .header-item {
    display: flex;
    align-items: center;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      overflow: hidden;
    }

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      margin-right: 2px;
      background: #f00;
    }
  }

  .time {
    color: #999;
    width: 90px;
    text-align: center;
  }
}
</style>
